import { FC, SVGProps } from 'react';

export const UserFollowingIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.7501 4C12.0222 4 9.00015 7.02208 9.00015 10.75C9.00015 13.2824 10.3947 15.489 12.4577 16.6439C8.50731 17.7633 5.04813 20.8365 4.01557 25.8487C3.932 26.2544 4.19313 26.651 4.59882 26.7346C5.00451 26.8182 5.40115 26.557 5.48472 26.1513C6.64688 20.51 11.2763 17.6723 15.9022 17.6634C17.5294 17.6603 19.1437 18.0068 20.5948 18.7044C20.843 18.8237 21.1352 18.8189 21.3713 18.6772C21.869 18.3786 21.8752 17.6654 21.3547 17.4087C20.6483 17.0602 19.9086 16.785 19.1495 16.5828C21.1536 15.4123 22.5001 13.2384 22.5001 10.75C22.5001 7.02208 19.4781 4 15.7501 4ZM10.5001 10.75C10.5001 7.85051 12.8507 5.5 15.7501 5.5C18.6496 5.5 21.0001 7.85051 21.0001 10.75C21.0001 13.6495 18.6496 16 15.7501 16C12.8507 16 10.5001 13.6495 10.5001 10.75Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M27.8174 21.0602C28.0693 20.8095 28.0595 20.4151 27.7944 20.1758C27.5251 19.9329 27.0964 19.9431 26.8406 20.1976L21.5452 25.4657L19.148 23.1944C18.8854 22.9456 18.4566 22.9456 18.194 23.1944C17.9353 23.4394 17.9353 23.834 18.194 24.079L21.08 26.8134C21.2072 26.9339 21.382 27.0021 21.5653 27C21.7485 26.9978 21.9214 26.9257 22.0454 26.8024L27.8174 21.0602Z"
			fill="currentColor"
		/>
	</svg>
);
